import { actionCreator } from '@ardoq/rxbeach';
import { GroupingAndFormattingRules } from './historyTypes';
import { ViewIds } from '@ardoq/api-types';

export type NewHistoryEntryRequestedPayload = {
  transactionId: string;
  viewName: ViewIds;
};

export const newHistoryEntryRequested =
  actionCreator<NewHistoryEntryRequestedPayload>(
    '[loadedStateHistory] NEW_HISTORY_ENTRY_REQUESTED'
  );

export const pushGroupingAndFormattingRulesToHistory =
  actionCreator<GroupingAndFormattingRules>(
    '[loadedStateHistory] PUSH_GROUPING_AND_FORMATTING_RULES_TO_HISTORY'
  );

export const viewpointLoadingStatusChanged = actionCreator<boolean>(
  '[loadedStateHistory] VIEWPOINT_LOADING_CHANGED'
);
